import { render, staticRenderFns } from "./RecordToolbar.vue?vue&type=template&id=2f286cdf&scoped=true&"
import script from "./RecordToolbar.vue?vue&type=script&lang=js&"
export * from "./RecordToolbar.vue?vue&type=script&lang=js&"
import style0 from "./RecordToolbar.vue?vue&type=style&index=0&id=2f286cdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f286cdf",
  null
  
)

export default component.exports